import axios from 'axios';
import { createUser } from '../../api/users';

export const FETCHING_TECHNICIANDATA = 'FETCHING_TECHNICIANDATA';
export const LOGIN = 'LOGIN';
export const TECHNICAIN_SIGNUP = 'TECHNICAIN_SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const SET_INVITE_USER_MODAL = 'SET_INVITE_USER_MODAL';
export const SET_EDIT_USER_MODAL = 'SET_EDIT_USER_MODAL';
export const SET_DELETE_USER_MODAL = 'SET_DELETE_USER_MODAL';
export const SET_EDIT_USER_DATA = 'SET_EDIT_USER_DATA';
export const SET_DELETE_USER_DATA = 'SET_DELETE_USER_DATA';
export const SET_ROLE_MODAL = 'SET_ROLE_MODAL';
export const SET_ROLE_VALUE = 'SET_ROLE_VALUE';
export const SET_ADD_USER_MODAL = 'SET_ADD_USER_MODAL';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_CUSTOMER_LOGIN_USER = 'SET_CUSTOMER_LOGIN_USER';

const setLoginUser = data => ({
  type: LOGIN,
  payload: { data },
});

const setIsFetching = data => ({
  type: FETCHING_TECHNICIANDATA,
  payload: { data },
});


export const inviteUserModal = data => ({
  type: SET_INVITE_USER_MODAL,
  payload: { data },
});

const editUserModal = data => ({
  type: SET_EDIT_USER_MODAL,
  payload: { data },
});

const setDeleteUserModal = data => ({
  type: SET_DELETE_USER_MODAL,
  payload: { data },
});

const setTechnicianUser = data => ({
  type: TECHNICAIN_SIGNUP,
  payload: { data },
});

const setLoginCustomerUser = data => ({
  type: SET_CUSTOMER_LOGIN_USER,
  payload: { data },
});

const setEditUserData = data => ({
  type: SET_EDIT_USER_DATA,
  payload: { data },
});


const setDeleteUserData = data => ({
  type: SET_DELETE_USER_DATA,
  payload: { data },
});

const setRoleModal = data => ({
  type: SET_ROLE_MODAL,
  payload: { data },
});

const setRoleValue = data => ({
  type: SET_ROLE_VALUE,
  payload: { data },
});

const userRoles = data => ({
  type: SET_USER_ROLE,
  payload: { data },
});


export const loginUserData = loginData => async dispatch => {
  try {
    dispatch(setLoginUser(loginData));
  } catch (error) {
    console.log(error);
  }
};

export const invitedTechUsers = signUpData => async dispatch => {
  try {
    dispatch(setTechnicianUser(signUpData));
  } catch (error) {
    console.log(error);
  }
};

export const getAllCustomerLogin = signUpData => async dispatch => {
  try {
    dispatch(setLoginCustomerUser(signUpData));
  } catch (error) {
    console.log(error);
  }
};


export const isFetching = data => dispatch => {
  dispatch(setIsFetching(data));
};


export const setInviteUserModal = data => dispatch => {
  dispatch(inviteUserModal(data));
};

export const setEditUserModal = data => dispatch => {
  dispatch(editUserModal(data));
};

export const deleteUserModal = data => dispatch => {
  dispatch(setDeleteUserModal(data));
};

export const editUserData = data => dispatch => {
  dispatch(setEditUserData(data));
};


export const deleteUserData = data => dispatch => {
  dispatch(setDeleteUserData(data));
};


export const roleModal = data => dispatch => {
  dispatch(setRoleModal(data));
};

export const editRoleData = data => dispatch => {
  dispatch(setRoleValue(data));
};

export const setUserRole = data => dispatch => {
  dispatch(userRoles(data));
};
